import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TaskDetailsComponent } from '../task-details/task-details.component';
import { Task } from 'src/app/___LOGIC/___common/__interfaces/Task';

declare var jQuery;

interface Stage {
  name: string;
  tasks: Task[];
}

@Component({
  selector: 'app-visa-pipeline',
  templateUrl: './visa-pipeline.component.html',
  styleUrls: ['./visa-pipeline.component.css']
})
export class VisaPipelineComponent implements OnInit {

  numberOfStages: number = 6; // Example value, set this dynamically as needed
  gridTemplateColumns: string;
  
    stages: Stage[] = [
      { name: 'Travel', tasks: [] },
      { name: 'Arrival', tasks: [] },
      { name: 'Adaptation', tasks: [] }
    ];

    stagesUniversity: Stage[] = [
      { name: 'Elegir Universidad y Aplicar', tasks: [] },
      { name: 'Reserva y Pago', tasks: [] },
      { name: 'Preparar Documentos', tasks: [] },
      { name: 'Solicitud Visado', tasks: [] }
    ];
  
    timelineUniversity = ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'];
    timeline = ['Mayo','Junio','Julio','Agosto', 'Septiembre', 'Octubre'];

    startLessons = '2024-09-15';
    content = {};
    config = {
      premiumMode: true
    }
  
    constructor(private dialog: MatDialog) {

      const contrastColors = [
        '#2D5C6E', // Dark Cool
        '#2196F3',
        '#336B87', // Celeste claro
        '#2196F3',
        '#03A9F4', // Light Cool
        '#64B5F6', // Celeste 
        '#F06292', // Light Warm
        '#9575CD', // Dark Cool
        '#9C27B0', // Dark Cool
        '#BA68C8', // Dark Cool
        '#7986CB', // morado claro opaco
        '#673AB7', // Morado live
        '#F44336', // Dark Warm
        '#FF8A65', // Light Warm
        '#E57373', // Light Warm
        '#2196F3', // azul claro
        '#009688', // Dark Cool
        '#4CAF50', // Light Cool
        '#8BC34A', // Light Cool
        '#CC6636', // Dark Warm
        '#4DB6AC', // Light Cool
        '#CC6666', // arcilla
        '#3F51B5', // Morado oscuro
      ];
    
      this.stagesUniversity[0].tasks = [
        { 
          name: 'Búsqueda de becas',
          description: 'En nuestro servicio de Búsqueda de Becas, nos dedicamos a ayudar a estudiantes que desean continuar su educación en Europa a encontrar las oportunidades de financiamiento que mejor se adapten a sus necesidades y aspiraciones académicas. Sabemos que el costo de estudiar en el extranjero puede ser un desafío significativo, y nuestro objetivo es facilitar el proceso para que puedas enfocarte en lo que realmente importa: tu educación y desarrollo personal.',
          validation: false,
          start: 1, 
          end: 4, 
          color: '#2D5C6E', 
          duration: 3,
          steps:[
            { label: 'CONAPE', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
          ],
          links: [],
          docs: [],
          services: [
            { label: 'Asesoramiento Personalizado', description: 'Evaluamos tu perfil académico y profesional para identificar las becas más adecuadas para ti. Ofrecemos orientación sobre los tipos de becas disponibles, incluyendo becas completas, parciales, por méritos, por necesidades económicas y específicas de ciertas áreas de estudio.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            { label: 'Investigación Exhaustiva:', description: 'Realizamos una búsqueda detallada y actualizada de becas ofrecidas por universidades, gobiernos, organizaciones privadas y fundaciones en Europa. Te proporcionamos una lista de becas que coinciden con tu perfil y tus objetivos académicos.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            { label: 'Asistencia en la Aplicación', description: 'Te ayudamos a preparar una solicitud sólida, revisando y mejorando tu carta de motivación, currículum vitae y otros documentos requeridos. Te orientamos en el proceso de recopilación de cartas de recomendación y la preparación para entrevistas.', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
            { label: 'Soporte Continuo', description: 'Brindamos seguimiento constante durante todo el proceso de aplicación, respondiendo a tus preguntas y resolviendo tus dudas. Te mantenemos informado sobre fechas límite importantes y te recordamos los pasos a seguir para asegurar una aplicación exitosa.', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) }
          ],
          /*moreBenefits: [
              Beneficios del Servicio:
              Ahorro de Tiempo: Nos encargamos de la búsqueda de becas, permitiéndote concentrarte en tus estudios y preparación.
              Acceso a Oportunidades Exclusivas: Aprovechamos nuestra red de contactos y base de datos para encontrar becas que no están fácilmente disponibles al público general.
              Mejora de la Competitividad: Te ayudamos a presentar una solicitud profesional y competitiva, aumentando tus posibilidades de obtener una beca.
              Tranquilidad y Seguridad: Contarás con el apoyo de expertos que te guiarán a lo largo de todo el proceso.
          ] */
          moreInfo: '',
          estimatedTime: '' 
        },
        { 
          name: 'Elección de Universidad',
          description: "Nuestro servicio de Elección de Universidad y Plan de Estudios está diseñado para estudiantes que desean continuar su educación en Europa y buscan orientación experta para tomar decisiones informadas y estratégicas sobre su futuro académico. Entendemos que elegir la universidad y el programa de estudios adecuados puede ser una tarea desafiante, y estamos aquí para facilitar este proceso, asegurando que cada estudiante encuentre la opción que mejor se alinee con sus metas y aspiraciones.",
          steps: [],
          links: [],
          docs: [],
          services: [
            {
              label: "Asesoramiento Personalizado",
              description: "Realizamos una evaluación detallada de tu perfil académico, intereses, habilidades y objetivos profesionales. Ofrecemos sesiones de asesoramiento uno a uno para comprender tus preferencias y ayudarte a definir tus prioridades en la búsqueda de universidades y programas de estudio."
            },
            {
              label: "Investigación de Universidades",
              description: "Proporcionamos una lista personalizada de universidades en Europa que se ajustan a tus criterios específicos, incluyendo ubicación, reputación académica, opciones de programas y costos. Te informamos sobre los requisitos de admisión, fechas límite y procesos de aplicación de cada institución."
            },
            {
              label: "Selección de Programas de Estudio",
              description: "Te ayudamos a identificar y comparar programas de estudio que se alineen con tus intereses y objetivos profesionales. Te brindamos información detallada sobre los contenidos de los programas, duración, oportunidades de prácticas y perspectivas de carrera."
            },
            {
              label: "Preparación de Solicitudes",
              description: "Asistimos en la preparación de todos los documentos necesarios para las solicitudes, incluyendo cartas de motivación, currículum vitae, y cartas de recomendación. Revisamos y mejoramos tus documentos para asegurar que presenten tu perfil de la mejor manera posible."
            },
            {
              label: "Soporte Continuo vía WhatsApp",
              description: "Ofrecemos apoyo continuo durante todo tu proceso de transición a la universidad en Europa, respondiendo a tus preguntas y ayudándote a resolver cualquier problema que surja. Te conectamos con recursos adicionales, como tutorías, asesoramiento académico y apoyo emocional, para asegurar tu éxito y bienestar durante tus estudios."
            }
          ],
          /* moreBenefits: [
            "Decisiones Informadas",
            "Ahorro de Tiempo",
            "Mayor Oportunidad de Éxito",
            "Tranquilidad y Confianza"
          ] */
        validation: false,
          start: 1, end: 5, color: '#336B87', duration: 4,moreInfo: '',estimatedTime: ''
        },
        { 
          name: 'Elección del plan de estudios',
          description: "Nuestro servicio de Elección de Plan de Estudios está diseñado para estudiantes que desean continuar su educación en Europa y buscan orientación experta para tomar decisiones informadas y estratégicas sobre su futuro académico. Entendemos que elegir el programa de estudios adecuado puede ser una tarea desafiante, y estamos aquí para facilitar este proceso, asegurando que cada estudiante encuentre la opción que mejor se alinee con sus metas y aspiraciones.",
          steps: [],
          links: [],
          docs: [],
          services: [
            {
              label: "Asesoramiento Personalizado",
              description: "Realizamos una evaluación detallada de tu perfil académico, intereses, habilidades y objetivos profesionales. Ofrecemos sesiones de asesoramiento uno a uno para comprender tus preferencias y ayudarte a definir tus prioridades en la selección de programas de estudio."
            },
            {
              label: "Selección de Programas de Estudio",
              description: "Te ayudamos a identificar y comparar programas de estudio que se alineen con tus intereses y objetivos profesionales. Te brindamos información detallada sobre los contenidos de los programas, duración, oportunidades de prácticas y perspectivas de carrera."
            },
            {
              label: "Investigación de Universidades",
              description: "Proporcionamos una lista personalizada de universidades en Europa que ofrecen los programas de estudio que se ajustan a tus criterios específicos. Te informamos sobre los requisitos de admisión, fechas límite y procesos de aplicación de cada institución."
            },
            {
              label: "Preparación de Solicitudes",
              description: "Asistimos en la preparación de todos los documentos necesarios para las solicitudes, incluyendo cartas de motivación, currículum vitae, y cartas de recomendación. Revisamos y mejoramos tus documentos para asegurar que presenten tu perfil de la mejor manera posible."
            },
            {
              label: "Orientación en el Proceso de Admisión",
              description: "Te guiamos paso a paso en el proceso de admisión, asegurando que cumplas con todos los requisitos y fechas límite. Te proporcionamos recursos y consejos para preparar entrevistas de admisión y exámenes de ingreso, si fueran necesarios."
            },
            {
              label: "Planificación Académica",
              description: "Ayudamos a planificar tu itinerario académico, incluyendo la selección de cursos, organización del calendario y optimización de tu carga de estudios. Te orientamos sobre cómo equilibrar tus estudios con actividades extracurriculares, trabajo y vida personal para maximizar tu experiencia educativa."
            },
            {
              label: "Soporte Continuo",
              description: "Ofrecemos apoyo continuo durante todo tu proceso de transición a la universidad en Europa, respondiendo a tus preguntas y ayudándote a resolver cualquier problema que surja. Te conectamos con recursos adicionales, como tutorías, asesoramiento académico y apoyo emocional, para asegurar tu éxito y bienestar durante tus estudios."
            }
          ],
          /* moreBenefits: [
            "Decisiones Informadas",
            "Ahorro de Tiempo",
            "Mayor Oportunidad de Éxito",
            "Tranquilidad y Confianza"
          ] */
          validation: false,
          start: 2, end: 3, color:  '#2196F3', duration: 4,moreInfo: '',estimatedTime: '' 
        },
        { 
          name: 'Contactar con la Universidad',
          description: "Nuestro servicio de Contactar con la Universidad está diseñado para estudiantes que desean continuar su educación en Europa y necesitan asistencia en el proceso de comunicación con las universidades. Este servicio facilita el contacto directo con las instituciones educativas, asegurando que los estudiantes obtengan toda la información necesaria y que sus consultas sean respondidas de manera eficiente y precisa.",
          steps: [],
          links: [],
          docs: [],
          services: [
            {
              label: "Coordinación de Entrevistas",
              description: "Te ayudamos a coordinar entrevistas y reuniones con representantes de las universidades. Te proporcionamos recursos y consejos para preparar y llevar a cabo estas interacciones de manera efectiva."
            },
            {
              label: "Resolución de Consultas",
              description: "Te asistimos en la interpretación y respuesta de las comunicaciones recibidas de las universidades. Nos aseguramos de que entiendas completamente las respuestas y te ayudamos a formular respuestas adicionales si es necesario."
            },
            {
              label: "Seguimiento Continuo",
              description: "Brindamos apoyo continuo durante todo el proceso de comunicación con las universidades, respondiendo a tus preguntas y ayudándote a resolver cualquier problema que surja. Mantenemos un registro de todas las interacciones para asegurar un seguimiento eficaz."
            }
          ],
          /* moreBenefits: [
            "Decisiones Informadas",
            "Ahorro de Tiempo",
            "Mayor Oportunidad de Éxito",
            "Tranquilidad y Confianza"
          ] */
          validation: false,
          start: 3, 
          end: 4, 
          color: '#03A9F4', 
          duration: 3,
          moreInfo: '',
          estimatedTime: ''
        }
      ];

      this.stagesUniversity[1].tasks = [
        { name: 'Aplicar en período de admisión',
          description: "Nuestro servicio de Aplicar en período de admisión está diseñado para estudiantes que desean continuar su educación en Europa y necesitan asistencia en el proceso de aplicación durante el período de admisión. Este servicio te guía paso a paso para asegurarte de que cumplas con todos los requisitos y fechas límite, presentando una solicitud sólida y completa.",
          steps: [],
          links: [],
          docs: [],
          services: [
            {
              label: "Evaluación Inicial",
              description: "Realizamos una evaluación de tu perfil académico y profesional para identificar las universidades y programas de estudio más adecuados para ti. Te proporcionamos una lista de los requisitos específicos de cada institución."
            },
            {
              label: "Preparación de Documentos",
              description: "Te asistimos en la preparación de todos los documentos necesarios para la aplicación, incluyendo cartas de motivación, currículum vitae, transcripciones académicas y cartas de recomendación. Revisamos y mejoramos tus documentos para asegurar que presenten tu perfil de la mejor manera posible."
            },
            {
              label: "Gestión de Fechas Límite",
              description: "Te mantenemos informado sobre todas las fechas límite importantes y te recordamos los pasos a seguir para asegurar una aplicación exitosa. Te proporcionamos un calendario personalizado para que puedas gestionar tu tiempo de manera efectiva."
            }
        ],
        /* moreBenefits: [
          "Decisiones Informadas",
          "Ahorro de Tiempo",
          "Mayor Oportunidad de Éxito",
          "Tranquilidad y Confianza"
        ] */
          validation: false,
          start: 2, end: 5, color: '#64B5F6', duration: 6,moreInfo: '',estimatedTime: '' 
        },
        { name: 'Título oficial o asignaturas convalidadas de los estudios cursados anteriormente',
          description: 'Solicitar a la Universidad o centro de estudios en Costa Rica (o el país de procedencia). Apostillado por casa Amarilla',
          start: 4,validation: true, end: 7, color: contrastColors[12], duration: 3,
            steps: [
              { label: 'Solicitar título', description: 'Solicitar el título oficial de la Universidad', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Paso 2', description: '', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Ir al CONESUP', description: 'Firmar el título en el CONESUP.', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Apostilla', description: 'Apostillar título.', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
            ],
            links: [],
            docs: [],
            services: [],
            moreInfo: '',
            estimatedTime: '1 semana'
        },
        { name: 'Pagar matrícula',
          description: '', start: 5,
          services: [],
          links: [],
            docs: [],
          validation: false, end: 7, color: contrastColors[10], duration: 2, steps: [],moreInfo: '',estimatedTime: '' 
        },
        { name: 'Recibos de pagos realizados',
          description: 'Documentación sobre costo de los estudios y pagos realizados', start: 6,
          validation: false, end: 7, color: contrastColors[9], duration: 4, 
          steps: [
            { label: 'Solicitar recibos', description: 'Solicitar los recibos de todos los pagos realizados hasta el momento.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            { label: 'Adjuntarlos a la carpeta de Drive de documentos.', description: '', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
          ],
          services: [

          ],
          /* otherServices: [
          Mensajero
          Contratar seguro médico
          ] */
          links: [],
            docs: [],
          moreInfo: '',estimatedTime: '' 
        }, 
        { name: 'Carta de admisión',
          description: 'En el certificado deberá constar: Nombre del centro de Estudios, dirección fisica, fecha de inicio y finalización de los estudios. (solicitar a la Universidad o centro de estudios).',
          start: 7,
          services: [],
          links: [],
            docs: [],
          validation: false, end: 3, color: contrastColors[7], duration: 4, steps: [],moreInfo: '',estimatedTime: '' 
        }
      ];
      
      // STAGE PREPARAR DOCS
      this.stagesUniversity[2].tasks = [
          { 
            name: 'Formulario Solicitud Visado',
            description: 'Rellenar el formulario de la Embajada de España.',
            validation: false,
            start: 1, end: 3, color: contrastColors[11], duration: 3,
            links: [],
          docs: [],
            steps: [
              { label: 'Rellenar los datos personales', description: 'Número de pasaporte: Utilizar el número que está arriba a la derecha en tu pasaporte', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Rellenar el Lugar Fecha', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Firmar a mano', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Escanear y subirlo a la carpeta de Drive', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) }
            ],
            services: [
              { label: 'Asistencia para rellenar formulario', description: 'Explicación detallada de cómo debes rellenar el formulario', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) }
            ],
            /* docs: [], */
            moreInfo: '',
            estimatedTime: '' 
          },
          { 
            name: 'Fotografía',
            description: 'Una fotografía reciente, tamaño carné (3x4 cm), tomada de frente, con la cara descubierta. Foto de estudio a color, con fondo completamente blanco. **Se pueden pedir fotos extra por que luego se van a utilizar más para otros trámites.',
            start: 1,
            services: [],
            validation: false, end: 3, 
            color: '#F06292', 
            duration: 2,
            links: [],
          docs: [],
            steps: [],moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Pasaporte válido y en vigor',
            description: 'Original y una fotocopia de la página o páginas con datos biométricos del pasaporte (página con la foto y datos personales). El pasaporte le será devuelto inmediatamente después de presentar la solicitud. Al momento de la cita de solicitud de visado, debe tener una validez de al menos 1.5 - 2 años (debe ser válido, como mínimo, para toda la duración de la estancia prevista y tener dos páginas en blanco). No se admiten pasaportes expedidos hace más 10 años.',
            start: 1,
            links: [],
          docs: [],
            services: [],
            validation: false, end: 3, color: contrastColors[6], duration: 2, steps: [],moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Prueba de disponibilidad de medios económicos',
            description: 'Se debe aportar la documentación que demuestre que se cuenta con los recursos económicos suficientes para cubrir durante el período solicitado: la subsistencia, alojamiento y, en su caso, para garantizar el retorno a Costa Rica. La cantidad mínima exigida equivale al 100% del IPREM (Indicador Público de Renta de Efectos Múltiples. El monto ronda los 580 Euros mensuales. Para ello, se debe aportar alguno de los siguientes documentos:',
            start: 1,
            links: [],
          docs: [],
            services: [
              { label: 'Guía y acompañamiento', description: 'Explicación detallada, guía y acompañamiento para cumplir este requisitos.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) }
            ],
            validation: false, end: 7, color: contrastColors[14], duration: 3,
            steps: [
              { label: 'Estados de cuenta', description: 'Solicitar el título oficial de la Universidad', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Certificado de concesión de becas y/o créditos educativos.', description: 'Solicitar el título oficial de la Universidad', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Declaración jurada', description: 'Certificado notarial en donde el familiar o allegado declara que va a hacerse cargo de los gastos del solicitante. En caso de seleccionar esta última opción, se deben aportar los estados de cuenta bancaria de los últimos tres meses, emitidos y sellados por el banco, indicando el nombre completo del titular de la cuenta y la moneda.  Apostillado por la Casa Amarilla.', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Validar Firma ', description: 'Validar la firma del notario en la Dirección de Notariado', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Apostilla', description: 'Apostillar declaración jurada.', completed: false, formControl: new FormControl(), formGroup: new FormGroup({}) },
            ],
            moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Certificado médico', 
            description: 'Para cuando la duración de los estudios supere los seis meses. Este documento acredita que el solicitante no padece ninguna de las enfermedades que pudieran tener repercusiones de Salud Pública graves de con conformidad con los dispuesto en el R.S.I. de 2005. El certificado médico se debe de obtener con un médico inscrito en el Colegio de Médicos de Costa Rica. Posteriormente hay que llevar ese certificado al Colegio de Médicos acreditando al médico firmante y finalmente tiene que ser Apostillado por casa Amarilla ',
            start: 1,
            links: [],
          docs: [],
            services: [
              { label: 'Guía para obtener certificado médico', description: 'Te explicaremos los detalles necesarios en este requisito para que puedas apostillarlo y conseguir el documento en el plazo correcto.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            ],
            validation: false, end: 7, 
            color: contrastColors[13], duration: 3, 
            steps: [
              { label: 'Solicitar certificado a un médico', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Validar en Colegio de Médicos', 
                description: 'Sellar el certificado en el colegio de médicos. No se requiere cita, y el trámite no suele tardar más de 30 min-1h.', 
                completed: true, 
                formControl: new FormControl(), 
                formGroup: new FormGroup({}) 
              },
            ],moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Seguro médico',
            description: 'Para cuando la duración de los estudios supere los seis meses. Se debe pedir una carta a la empresa aseguradora donde acredite que posee cobertura médica. El seguro debe cubrir todos los riesgos asegurados por el sistema público de salud en España y tiene que tratarse de seguros de salud (no de viaje). Apostillado por la Casa Amarilla', 
            validation: false,
            links: [],
          docs: [],
            services: [
              { label: 'Guía, asistencia y seguimiento continuo para contratar el seguro médico', description: 'Te ayudaremos a contratar un seguro médico diseñado para estudiantes que van a España. Con un precio aproximad total de 420 EUR por 12 meses de cobertura.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            ],
            start: 1, end: 7, color: contrastColors[16], duration: 5, 
            steps: [
              { label: 'Rellenar Formulario', description: 'Rellenar Formulario de Solicitud de la aseguradora ASISA', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Rellenar Cuestionario', description: 'Rellenar Cuestionario de la aseguradora ASISA', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Fotografía pasaporte', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Definir período de cobertura (mínimo 12 meses)', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Enviaremos información a la correduría', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Pago vía enlace seguro', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: 'Certificado de cobertura PDF', description: '', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            ],
            moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Certificado antecedentes penales',
            description: '**Para cuando la duración de los estudios supere los seis meses y solo para mayores de edad. Se solicita para "uso internacional".Se puede sacar de 3 maneras: Apostillado por la Casa Amarilla', 
            validation: false,
            links: [],
          docs: [],
            services: [
              { label: '', description: 'Explicación detallada y accompañamiento para cumplir este requisito.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
            ],
            start: 2, end: 7, color: contrastColors[17], duration: 2, 
            steps: [
              { label: '', description: 'En el Registro Judicial en San José (edificio Anexo A del Poder Judicial). El horario de atención es de lunes a viernes de 7:30 a.m. a 4:30 p.m y dan el documento el mismo dia.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: '', description: 'Completando el formulario en el sitio web del Poder Judicial (www.poder-judicial.go.cr), indicando la oficina donde desea retirarla en los próximos cinco días hábiles.  ', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },
              { label: '', description: 'En las Administraciones Regionales. Consultar los horarios de atención para este trámite.', completed: true, formControl: new FormControl(), formGroup: new FormGroup({}) },

            ],moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Solicitar cita del apostilla',
            description: '',
            validation: false,
            services: [],
            links: [],
          docs: [],
            /* links: [
              'https://www.rree.go.cr/?sec=servicios&cat=autenticaciones&cont=734'

              General
              https://www.rree.go.cr/?sec=servicios&cat=autenticaciones
            ] */
            start: 2, end: 6, color: contrastColors[18], duration: 3, steps: [],moreInfo: '',estimatedTime: '' 
          },
          { 
            name: 'Apostillar documentos',
            description: '',
            validation: false,
            links: [],
          docs: [],
            services: [],
            start:3, end: 7, color: contrastColors[20], duration: 6, steps: [],moreInfo: '',estimatedTime: '' 
          },
      ];
      
      this.stagesUniversity[3].tasks = [
          { 
            name: 'Solicitar cita del visado',
            description: '',
            start: 1,
            services: [],
            links: [],
          docs: [],
            validation: false, end: 6, color: contrastColors[21], duration: 5, steps: [],moreInfo: '',estimatedTime: ''},
          { 
            name: 'Entregar documentos embajada España',
            description: '',
            start: 3,
            services: [],
            links: [],
            docs: [],
            validation: false, end: 6, color: contrastColors[19], duration: 6, steps: [],moreInfo: '',estimatedTime: '' },
          { 
            name: 'Entrega del visado',
            description: '',
            start: 4,
            services: [],
            links: [],
            docs: [],
            validation: false,
              end: 6, color: contrastColors[21], duration: 6, steps: [],moreInfo: '',estimatedTime: '' 
          },
      ];
    };
  
    ngOnInit(): void {
      /*   */
      this.loadNumberOfStages();
      this.setGridTemplateColumns();
      for(const [index, value] of this.stagesUniversity.entries()){
        this.updateTaskPositions(index,this.stagesUniversity);
      }
    }

    ngAfterViewInit(): void {
      (function($){
        $('.tasks-container').on('wheel', function (e) {
          if (e.originalEvent.deltaY !== 0) {
            this.scrollLeft += e.originalEvent.deltaY;
            e.preventDefault();
          }
        });
  
      })(jQuery)

    }

    setTimeline(){
      // draw mmonths at the bottom
    }
  
    drop(event: CdkDragDrop<Task[]>, stageIndex: number,stages): void {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
  
      this.updateTaskPositions(stageIndex,stages);
    }
  
    updateTaskPositions(stageIndex: number,stages): void {
      const stageTasks = stages[stageIndex].tasks;
      stageTasks.forEach((task, index) => {
        /* task.start = task.start+index; */
        task.end = task.start + task.duration; // Adjust task duration as needed
      });
    }


  loadNumberOfStages(): void {
    // Replace this with your actual logic to get the number of stages
    this.numberOfStages = 8; // Example value
  }

  setGridTemplateColumns(): void {
    this.gridTemplateColumns = `repeat(${this.numberOfStages}, 1fr)`;
  }

  openTaskDetails(task: any): void {
    const dialogRef = this.dialog.open(TaskDetailsComponent, {
      width: '600px',
      data: {
        task: task,
        premiumMode: this.config.premiumMode,
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  }